import React, { useEffect } from 'react';
import Button from './Button';

import '../stylesheets/C.scss';

import { useYouTube } from '../hooks';

function F(props) {
  const youTubeAPIPromise = useYouTube();

  useEffect(() => {
    youTubeAPIPromise.then((yt) => {
      let player = new yt.Player('yt-wild-in-alaska', {
        height: '360',
        width: '640',
        videoId: '2nw4P2n5xrw',
        playerVars: { rel: 0, enablejsapi: 1, autoplay: 1, mute: 1, loop: 1, listType: 'playlist', list: 'PL2LNe5vmCj3ayzzIAEMHmq0s7BS47cdTj' },
        title: 'Maah Daah Hey',
      });
    });
  }, [youTubeAPIPromise]);

  return (
    <section className="f">
      <div className="video-section">
        <div className="pie-video" id="yt-wild-in-alaska">
          <div id="pie-yt-video"></div>
        </div>
      </div>
      <div className="top-section">
        <h1>When you have people you can affect, that’s wealth.</h1>
        <h2>
          For Nick and Lindsey Ybarra, the Maah Daah Hey Trail is a place where people come together. See how the Ybarras are reimagining wealth by making an impact on their
          community.
        </h2>
      </div>
      <Button message={'Learn More'} link={`${props.stagingUrl}the-wealth-diaries/`} />
    </section>
  );
}

export default F;
